// extracted by css-extract-rspack-plugin
export default {"container":"NSF2dRrC34kEtaw2","content":"rSD5uIXQZGkc3Ke7","docked":"K1mHMbVsnUd5Sf0A","up":"qtMYIk_PABMSXIdw"};